import React, { useEffect, useState } from "react";
import ToolTip from "../Tooltip/Tooltip";
import "./Select.css";
import { TbChevronDown } from "react-icons/tb";

const Select = (props) => {
	const [error, setError] = useState("");

	useEffect(() => {
		setError(props.error);
	}, [props.error]);

	const handleChange = () => { };

	return (
		<label
			className="input-label"
			style={{ display: props.hidden ? "none" : "inline-flex" }}
		>
			{props.labelText && (
				<div
					className={`input-tooltip-container`}
					style={{
						width: "100%",
						textAlign: "left",
						color: props.disabled
							? "var(--textColorDisabled)"
							: "var(--textColor)",
					}}
				>
					{props.labelText}
					<ToolTip
						tooltipVisible={props.tooltipVisible}
						tooltipText={props.tooltipText}
					/>
				</div>
			)}
			<div className='select-wrapper'>
				<TbChevronDown />
				<select
					required={props.required}
					disabled={props.disabled}
					style={{
						backgroundColor: "var(--inputBackgroundColor)",
						boxShadow: props.disabled ? "none" : "var(--inputBoxShadow)",
						color: props.disabled
							? "var(--inputColorDisabled)"
							: "var(--inputColor)",
						opacity: props.disabled ? "0.5" : "1",
						...props.style,
					}}
					className={`appearance-none! disabled:opacity-50! disabled:cursor-not-allowed! ${error ? 'border-red-500!' : ''} ` + (props.className || "select input-form")}
					name={props.name}
					onChange={props.onChange || handleChange}
					value={props.value || ""}
				>
					<option value="" disabled hidden></option>
					{!!props.options &&
						props.options.map((option, index) => (
							<option
								key={index}
								value={option.value}
								className={props.optionClassName || ""}
							>
								{option.text}
							</option>
						))}
				</select>
			</div>
			{error && (
				<span className="error-message">
					{error}
				</span>
			)}
		</label>
	);
};

export default Select;
